// @flow

import type { EmployeeType } from "@modules/employee/types";

export type NameObj = { firstName: string, lastName: string };

export const formatAuthoredBy = (by: ?NameObj, placeholder: ?string = null): string => {
  if (by) {
    return `${by.firstName} ${by.lastName}`;
  } else if (placeholder) return placeholder;
  return "";
};

export const formatEmployeeJobTitles = (
  employee: ?EmployeeType,
  placeholder: ?string = null,
): ?string => {
  if (!employee || !employee.employmentSummary || !employee.employmentSummary.positions) {
    return placeholder;
  }

  return employee.employmentSummary.positions.map(position => position.jobTitle).join(", ");
};
